module.exports = __webpack_public_path__ + "static/media/circle-big.4c70d911.png";